import { createDirectus, rest, staticToken } from "@directus/sdk";

const token =
  sessionStorage.getItem("token") || "ksaoyDdV7-FDz8IA7zm6fq5hkF4uwgbf";

export const directus = createDirectus("https://emir.gtsolifk.ru:4443")
  .with(staticToken(token))
  .with(rest());
